import { checkHeaders } from '.'

const readyHeaders = (fileContent: string) => {
  const indexOfFirstNewline = fileContent.indexOf('\n')
  const originalHeaderRow = fileContent.substring(0, indexOfFirstNewline)
  const headerRowAsString = originalHeaderRow.replace(/['"\r]+/g, '')
  const headersArray = headerRowAsString.toLowerCase().split(',')
  return checkHeaders(headersArray)
}

const normalizeHeaders = (fileContent: string) => {
  const indexOfFirstNewline = fileContent.indexOf('\n')
  const originalHeaderRow = fileContent.substring(0, indexOfFirstNewline)
  return originalHeaderRow.toLowerCase() + fileContent.substring(indexOfFirstNewline)
}

export { readyHeaders, normalizeHeaders }
